import React, { useState, useEffect } from 'react';
import { Grid, FormControlLabel, Switch, TextField, Typography } from '@mui/material';

const CompletionOptions = ({ formData, handleNestedChange, tempTheme }) => {
  const [newVals, setNewVals] = useState(formData.completionOptions);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleDebouncedChange = debounce((name, value) => {
    setNewVals((prevVals) => ({
      ...prevVals,
      [name]: value,
    }));
  }, 3000);

  const handleInputChange = (event) => {
    const { name, type, checked, value } = event.target;
    const inputValue = type === 'checkbox' ? checked : value;
    handleNestedChange('completionOptions', name, inputValue);
    handleDebouncedChange(name, inputValue);
  };

  // useEffect(() => {
  //   console.log('New Values:', newVals);
  // }, [newVals]);

  return (
    <>
      <Typography
        variant="h6"
        sx={{ marginTop: 4 }}
      >
        Completion Options
      </Typography>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.completionOptions.showShareWidget}
                name="showShareWidget"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Show Share Widget upon Completion"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.completionOptions.showExtendedShareWidget}
                name="showExtendedShareWidget"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Show Extended Share Widget upon Completion"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Custom Last Step Finish Button Label"
            name="finishButtonLabel"
            value={formData.completionOptions.finishButtonLabel}
            onChange={handleInputChange}
            sx={tempTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.completionOptions.signOutOnCompletion}
                name="signOutOnCompletion"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Sign Out on Completion"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="External Link (Redirect) Last Step Finish Button"
            name="externalLinkOnCompletion"
            value={formData.completionOptions.externalLinkOnCompletion}
            onChange={handleInputChange}
            sx={tempTheme}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.completionOptions.showCompletionScreen}
                name="showCompletionScreen"
                onChange={handleInputChange}
                sx={tempTheme}
              />
            }
            label="Show Completion Screen"
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <TextField
            fullWidth
            label="Completion Screen Content"
            name="completionScreenContent"
            value={formData.completionOptions.completionScreenContent}
            onChange={handleInputChange}
            multiline
            rows={3}
            sx={tempTheme}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CompletionOptions;
